/**
 * Persistent credit-balance pill on the right side of the top bar.
 * Data comes from `<BalanceProvider>` (one fetch shared with the banner).
 * Renders nothing when balance hasn't loaded (e.g. pre-auth) — a broken
 * pill must never block the rest of the UI.
 */
import { NavLink } from 'react-router-dom';
import { CreditCard } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useBalance } from '@/providers/BalanceProvider';
import { useTheme } from '@/providers/ThemeProvider';

export default function CreditsPill() {
  const { isDark } = useTheme();
  const { balance, isLow } = useBalance();

  if (!balance) return null;

  const dollars = (balance.balanceCents / 100).toFixed(2);

  return (
    <NavLink
      to="/billing"
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium transition-colors',
        isLow
          ? isDark
            ? 'bg-red-500/15 text-red-300 hover:bg-red-500/20'
            : 'bg-red-100 text-red-700 hover:bg-red-200'
          : isDark
            ? 'bg-white/[0.06] text-white/70 hover:bg-white/[0.10]'
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200',
      )}
      title={isLow ? 'Balance is below the low-balance threshold — top up soon' : 'Credits'}
    >
      <CreditCard size={12} />
      <span className="tabular-nums">Credits: ${dollars}</span>
    </NavLink>
  );
}
